import Common from "../Common";
import Attempt from "./callback/Attempt";
import Destination from "./callback/Destination";
import Entry from "./callback/Entry";

const Callback = class extends Common {
	destination: InstanceType<typeof Destination>;
	entry: InstanceType<typeof Entry>;
	attempt: InstanceType<typeof Attempt>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.destination = new Destination(headers)
		this.entry = new Entry(headers)
		this.attempt = new Attempt(headers)
	}
}

export default Callback
